<template>
  <Layout>
    <!-- <PageHeader v-if="title" :title="title" :items="items" /> -->

    <Loader :loading="loadingExport" no-axios>
      <div class="">
        <div v-if="stats.length" class="row">
          <div class="title">{{ lodash.upperCase(title) }}</div>
          <div v-for="stat of stats" :key="stat.icon" :class="stat.wrapperClass">
            <Stat :loading="busy" v-bind="stat"/>
          </div>
        </div>
        <div v-if="!lodash.isEmpty(filterColumns)">
          <model-filter
              v-model="filter"
              :columns="filterColumns"
              :filterHandler="filterHandler"
              :modelVariable="modelVariable"
          />
        </div>
      </div>
      <div class="title">{{ lodash.upperCase($t("List")) }} {{ lodash.upperCase(title) }}</div>
      <div class="row">
        <model-index
            ref="table"
            :busy.sync="busy"
            :columns="columns"
            :filter-params.sync="filterParams"
            :from="from"
            :loading="loading"
            :models-paginated="modelsPaginated"
            :page.sync="page"
            :per-page.sync="perPage"
            :search.sync="search"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :total="totalFiltered"
            class="col-12"
            v-bind="$props"
            @create-click="handleCreate"
            @export-click="handleExport"
            @show-click="handleShow"
            @edit-click="handleEdit"
            @delete-click="handleDelete"
        >
          <template v-slot:card-tools>
            <b-button class="create-button me-2" variant="primary" @click="onClickCreateWeightNote" v-if="!denyCreate">
              <icon-base height="20" icon-color="white" width="20">
                <scales-line></scales-line>
              </icon-base>
              <span>
                      Buat Nota Timbang
                  </span>
            </b-button>
            <b-button class="create-button me-2" variant="primary" @click="onClickCreateUnloadOrder" v-if="!denyCreate">
              <icon-base height="20" icon-color="white" width="20">
                <factory-line></factory-line>
              </icon-base>
              <span>
                      Buat Nota Pabrik
                  </span>
            </b-button>
          </template>
        </model-index>
      </div>
    </Loader>
  </Layout>
</template>

<script>
import ModelFilter from "@/router/views/unload/filter";
import ModelIndex from "../models/index-v3";
import Swal from "sweetalert2";
import icons from "@/assets/icons";
import IconBase from "@/components/icon-base.vue";
import ScalesLine from "@/components/icons/ScalesLine.vue";
import FactoryLine from "@/components/icons/FactoryLine.vue";
import {hasAllowedAction as hasAllowedActionHelper} from "@/helpers/ui/allowedActions";

export default {
  extends: ModelIndex,
  components: {
    FactoryLine,
    ScalesLine,
    IconBase,
    ModelFilter
  },
  page: {
    title: "Nota Bongkar"
  },
  props: {
    // cardTitle: {
    //   default() {
    //     return "Nota Bongkar";
    //   }
    // },
    resourceRoute: {default: "unloads"},
    modelVariable: {default: "unload"},
    denyCreate: {
      type: Boolean,
      default() {
        return !this.$auth.hasPermissionTo("sale_order.create");
      }
    },
    searchPlaceholder: {
      default() {
        return "Cari berdasarkan ID folder, dibuat oleh dan total harga bongkar";
      }
    }
  },
  data() {
    return {
      title: "Nota Bongkar",
      items: [
        {
          text: "Nota Bongkar",
          href: "/unload",
          active: true
        }
      ],
      sortBy:
          (this.$route.query.sort &&
              this.$route.query.sort
                  .split("|")
                  .shift()
                  .split(",")
                  .shift()) ||
          "id",
      sortDesc:
          (this.$route.query.sort &&
              this.$route.query.sort
                  .split("|")
                  .shift()
                  .split(",")
                  .pop() === "desc") ||
          true,
      filterColumns: {
        "ticketable.ticket_id": {
          type: Array,
          label: `ID ${this.lodash.startCase(this.$t("tickets.singular"))}`,
          operator: "in",
          input_component: "ticket-multiselect-ajax"
        },
        id: {
          type: Array,
          label: `ID ${this.lodash.startCase(this.$t("unloads.singular"))}`,
          operator: "in",
          input_component: "unload-multiselect-ajax"
        },
        customer_id__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t("unloads.factory")),
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t("unloads.factory")),
          operator: "in",
          input_component: "factory-multiselect-ajax"
        },
        where_has_purchase_order_farmer_id__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t("customers.types.farmer")),
          placeholder: this.$t('Select {something}', {something: this.lodash.upperFirst(this.$t("customers.types.farmer"))}),
          operator: "in",
          input_component: "farmer-customer-multiselect-ajax"
        },
        "ticket.customer_type": {
          type: String,
          label: this.lodash.startCase(this.$t("tickets.customer_type")),
          operator: "eq",
          input_component: "customer-type-select"
        },
        ordered_at__between: {
          type: Array,
          label: `${this.$t("Date")} ${this.lodash.upperFirst(this.$t("unloads.singular"))}`,
          operator: "between",
          input_component: "datepicker-range"
        },
        where_has_purchase_order_id__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t("trips.purchase_order_id")),
          input_component: "purchase-order-multiselect-ajax",
          placeholder: this.lodash.upperFirst(
              this.$t(`Select {something}`, {something: this.$t("trips.purchase_order_id")})
          )
        },
        where_has_purchase_order_customer_id__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t("customers.types.partner")),
          input_component: "partner-customer-multiselect-ajax",
          placeholder: this.lodash.upperFirst(
              this.$t(`Select {something}`, {something: this.$t("customers.types.partner")})
          )
        },
        where_has_sub_product__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t('products.singular')),
          operator: "in",
          input_component: "sub-product-multiselect",
          options: ["deposit_goods", "harvest", "cash"]
        }
      },
      model: this.modelVariable
    };
  },
  computed: {
    icons() {
      return icons
    },
    columns() {
      return {
        ["unload"]: [
          {
            key: "ticket_id",
            label: this.lodash.startCase(this.$t("tickets.ticket_id")),
            thStyle: {width: "100px"},
            sortable: true,
            component: {
              props: ["item"],
              computed: {
                customLabel() {
                  return `${this.item.ticket_id}: ${this.$t(
                      `tickets.customer_types.${this.item.ticket.customer_type}`
                  )}`;
                }
              },
              template: '<router-link :to="`/tickets/${(item || {}).ticket_id}`">{{ customLabel }}</router-link>'
            }
          },
          {
            key: "trip_id",
            label: "ID Armada",
            sortable: true
          },
          {
            key: "id",
            label: "ID Nota Bongkar",
            sortable: true
          },
          {
            key: "ordered_at",
            label: "Tanggal Nota Bongkar",
            thStyle: {width: "150px"},
            sortable: true,
            formatter: value => {
              return this.$moment
                  .utc(value)
                  .local()
                  .format("DD MMM YYYY");
            }
          },
          {
            key: "sale_item_total_quantity",
            label: "Biomasa Bongkar",
            thStyle: {minWidth: "100px"},
            sortable: true,
            formatter: value =>
                value >= 500
                    ? `${this.$numeral(value / 1000).format("0,0.[000]")} ${this.$t("units.ton")}`
                    : `${this.$numeral(value).format("0,0.[000]")} ${this.$t("units.kg")}`
          },
          {
            key: "sale_item_total",
            label: "Total Harga Bongkar",
            thStyle: {minWidth: "100px"},
            component: {
              props: ["item"],
              computed: {
                customLabel() {
                  return `${this.item.ticket_id}: ${this.$t(
                      `tickets.customer_types.${this.item.ticket.customer_type}`
                  )}`;
                }
              },
              template: '<div style="text-align: right"><template v-if="!item.is_draft">{{$numeral(item.total).format("$ 0,0.[00]")}}</template><span v-else style="color: #D19C00">Nota Timbang</span></div>'
            }
          },
          {
            key: "customer.name",
            label: this.lodash.startCase(this.$t('unloads.destination_processing_plant')),
          },
          {
            key: "creator.name",
            label: "Dibuat Oleh",
            sortable: true
          },
          {key: "action", label: this.$t("Action"), class: "text-center", style: {width: "1%"}}
        ]
      };
    }
  },
  methods: {
    onClickCreateWeightNote() {
      this.$router.push('/weight_notes/create')
    },
    onClickCreateUnloadOrder() {
      this.$router.push('/unloads/create')
    },
    getModelName(value) {
      return value["order_id"];
    },
    delete(value) {
      return this.$axios.delete(`/sale_orders/${this.getModelKey(value)}`);
    },
    deleteSuccessAlert(something, id) {
      return Swal.fire({
        title: this.$t("Deleted") + "!",
        text: this.$t(`You deleted {something} {id}`, {something, id}),
        type: "success",
        confirmButtonClass: "btn btn-success btn-fill",
        buttonsStyling: false
      });
    },
    handleEdit(value) {
      this.$router.push({
        path: `${value.is_draft ? `/weight_notes/${this.getModelKey(value)}` : this.getModelKey(value)}/edit`,
        append: true
      });
    },
    handleDelete(value) {
      this.deleteConfirmAlert().then(result => {
        if (result.value) {
          this.delete(value)
              .then(() => this.$refs.table.$refs.table.refresh())
              .then(() => this.deleteSuccessAlert(this.$t("unloads.singular"), this.getModelKey(value)))
              .catch(error => this.failedAlert(error));
        }
      });
    },
    fetchModels(page = 1) {
      return this.$axios
          .get("/sale_orders", {
            params: {
              page: page,
              per_page: this.perPage,
              search: this.search,
              searchables: "unload",
              with: [
                "creator",
                "customer",
                "purchase_payments",
                "ticket",
                "ticketable",
                "tickets.sale_orders.sale_payments",
                "sale_items",
                "sale_items.purchase_item",
                "odoo_sale_order"
              ].join(","),
              sort: `${this.sortBy},${this.sortDesc ? "desc" : "asc"}`,
              type__in: "unload,cash,harvest,deposit_goods",
              ...this.filterParams
            }
          })
          .then(response => {
            const {
              data: {data, meta}
            } = response;
            this.models = data.map(datum => {
              return {
                ...datum,
                ...this.modelPolicy(datum)
              };
            });
            this.page = Number(meta.current_page);
            this.perPage = Number(meta.per_page);
            this.from = Number(meta.from);
            this.total = Number(meta.total);

            this.stats = [
              {
                title: this.lodash.startCase(this.$t("unloads.count")),
                value: this.$numeral(this.total).format("0,0 a"),
                valueTitle: this.$numeral(this.total).format("0,0"),
                icon: "bx bx-copy-alt",
                wrapperClass: "col-12 col-md-6 col-xl-4"
              }
            ];

            return response;
          })
          .catch(error => this.failedAlert(error));
    },
    hasAllowedAction(model, actions) {
      return hasAllowedActionHelper(model, actions);
    },
    modelPolicy(model) {
      return {
        _denyShow: false,
        _denyEdit: !this.hasAllowedAction(model, ["edit", "update"]),
        _denyDelete: !this.hasAllowedAction(model, ["delete", "destroy"])
      };
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep {
  .table-header-controls {
    width: 33rem;
    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .create-button {
    border-radius: var(--spacing-14-px, 4px);

    font: 500 13px/20px Inter;
    letter-spacing: 0.5px;
  }
}
</style>
